import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=fbfdee52&"
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbfdee52')) {
      api.createRecord('fbfdee52', component.options)
    } else {
      api.reload('fbfdee52', component.options)
    }
    module.hot.accept("./badge.vue?vue&type=template&id=fbfdee52&", function () {
      api.rerender('fbfdee52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/badge/badge.vue"
export default component.exports